<script lang="ts" setup>
import { useRoute } from 'vue-router'
import { Document, Setting, House, Open, Help, Opportunity } from '@element-plus/icons-vue'

import OrganizationSelector from '@/components/utilities/OrganizationSelector.vue'
import { useLayoutPreferencesStore } from '@/stores/layout/layoutPreferences'
import { storeToRefs } from 'pinia'
import { useActiveOrganization, useCan } from 'auth-package'
import OrganizationBar from '../utilities/OrganizationBar.vue'

const activeOrganization = useActiveOrganization()

const layoutPreferencesStore = useLayoutPreferencesStore()
const { isMenuOpen, isWorkspaceSwitcherEnabled, defaultOpeneds, isOrganizationBarOpen } =
    storeToRefs(layoutPreferencesStore)
const route = useRoute()

layoutPreferencesStore.setDefaultOpeneds(['campaign-management', 'campaign-configuration'])

const defaultRoute = () => {
    if (route.meta.activeMenuIndex && route.meta.activeMenuIndex instanceof Function) {
        return route.meta.activeMenuIndex(route)
    }

    return route.name
}

const openExternal = (url: string) => {
    window.open(url, '_blank', 'noopener,noreferrer')
}

//const carReadRole = useCan('CarRead')
</script>
<!--:width="layoutPreferencesStore.isMenuOpen ? '220px' : '64px'"-->

<template>
    <!-- <el-aside :width="isMenuOpen ? '240px' : '64px'" z-index="1"> -->
    <el-aside :width="isOrganizationBarOpen ? '245px' : '300px'" z-index="1">
        <!--REmoved for fix maybe important@open="()=>{console.log('Open Event fired'); layoutPreferencesStore.menuOpen()}"
            @close="()=>{console.log('Close event fired');layoutPreferencesStore.menuClose()}"-->
        <el-scrollbar height="100vh">
            <el-menu
                class="full-menu"
                :router="true"
                :default-openeds="defaultOpeneds"
                :collapse="!isMenuOpen"
                :collapse-transition="true"
                :default-active="defaultRoute()"
            >
                <OrganizationBar />
                <!-- <el-menu-item class="organization-selector-item" v-if="!isWorkspaceSwitcherEnabled">
                    <OrganizationSelector :size="isMenuOpen ? 'large' : 'small'" />
                </el-menu-item> -->

                <!-- <el-menu-item index="home" :route="{ name: 'home' }">
                    <el-icon>
                        <House />
                    </el-icon>
                    <template #title>{{ $t('adminSubMenu.home') }}</template>
                </el-menu-item> -->

                <CampaignManagerSubMenu />
                <!-- <HiveManagerSubMenu /> -->
                <!-- <NotificationManagerSubMenu /> -->

                <!-- <el-menu-item index="news" :route="{ name: 'news' }">
                    <el-icon>
                        <document />
                    </el-icon>
                    <template #title>{{ $t('adminSubMenu.news') }}</template>
                </el-menu-item> -->

                <!-- <el-menu-item @click="layoutPreferencesStore.menuToggle" class="down-item">
                    <el-icon>
                        <Switch />
                    </el-icon>
                    <template #title>{{ $t('adminSubMenu.menuOpenAndClose') }}</template>
                </el-menu-item> -->

                <!-- <el-menu-item @click="layoutPreferencesStore.darkModeToggle">
                    <el-icon>
                        <Sunrise />
                    </el-icon>
                    <template #title>{{ $t('adminSubMenu.toggleTheme') }}</template>
                </el-menu-item> -->

                <!-- <el-menu-item
                    @click="layoutPreferencesStore.workspaceSwitcherToggle"
                    class="down-item"
                >
                    <el-icon>
                        <Open />
                    </el-icon>

                    <template #title>{{ $t('adminSubMenu.toggleWorkspace') }}</template>
                </el-menu-item> -->

                <el-menu-item
                    class="down-item"
                    @click="
                        openExternal(
                            'https://prizific.atlassian.net/servicedesk/customer/portal/269/group/319/create/364'
                        )
                    "
                >
                    <el-icon>
                        <Opportunity />
                    </el-icon>
                    <template #title>{{ $t('adminSubMenu.suggestAFeature') }}</template>
                </el-menu-item>
                <el-menu-item
                    @click="
                        openExternal(
                            'https://prizific.atlassian.net/servicedesk/customer/portal/269'
                        )
                    "
                >
                    <el-icon>
                        <Help />
                    </el-icon>
                    <template #title>{{ $t('adminSubMenu.help') }}</template>
                </el-menu-item>
                <el-sub-menu index="settings">
                    <template #title>
                        <el-icon>
                            <setting />
                        </el-icon>
                        <span class="w-100">
                            <span>
                                {{ $t('adminSubMenu.settings') }}
                            </span>
                        </span>
                    </template>
                    <el-menu-item-group>
                        <template #title>
                            {{ $t('adminSubMenu.general') }}
                        </template>
                        <el-menu-item index="account" :route="{ name: 'accountSettings' }">
                            <template #title>
                                {{ $t('adminSubMenu.accountSettings') }}
                            </template>
                        </el-menu-item>
                        <el-menu-item
                            index="organization"
                            :route="{ name: 'organizationSettings' }"
                        >
                            <template #title>
                                {{ $t('adminSubMenu.organization') }}
                            </template>
                        </el-menu-item>

                        <el-menu-item
                            v-can="
                                'resource|organization-' +
                                activeOrganization.uuid +
                                '~OrganizationMs#read'
                            "
                            index="organization-members"
                            :route="{ name: 'organizationSettingsMembers' }"
                        >
                            <template #title>
                                {{ $t('adminSubMenu.members') }}
                            </template>
                        </el-menu-item>
                    </el-menu-item-group>
                </el-sub-menu>
            </el-menu>
        </el-scrollbar>
    </el-aside>
</template>

<style scoped lang="scss">
.el-aside {
    position: relative;
    overflow: hidden;

    // &::after {
    //     content: '';
    //     position: absolute;
    //     bottom: -2%;
    //     left: -10%;
    //     width: 80%;
    //     height: 80%;
    //     border-radius: 77px;
    //     background-color: rgba(var(--el-color-primary-rgb), 0.1);
    //     filter: blur(300px);
    //     pointer-events: none;
    //     user-select: none;
    //     z-index: 0;
    // }

    .full-menu {
        display: flex;
        flex-direction: column;
        height: 100vh;

        .down-item {
            margin-top: auto;
        }
    }

    .organization-selector-item {
        padding-left: 10px;
        padding-right: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
}
</style>
